import CenteredErrorMessage from './CenteredErrorMessage'

export default CenteredErrorMessage
